import { useMemo } from "react";
import { useAppSelector } from ".";
import { Content, MenuSection } from "@/types";
import { useNavigate } from "react-router-dom";
interface Props {
  structure?: MenuSection[];
  content?: Content[];
}

const useDishNavigation = ({ structure = [], content = [] }: Props) => {
  const navigate = useNavigate();

  const selectedDish = useAppSelector((state) => state.ui?.selectedMenuItem) as unknown as Content;

  const sortedDishes = useMemo(() => {
    return structure.reduce((acc, curr) => {
      const items = content.filter((c) => c.category === curr.category);
      return [...acc, ...items];
    }, [] as unknown as Content[]);
  }, [content, structure]);

  const onContinue = () => {
    const selectedIndex = sortedDishes.findIndex((d) => d.id === selectedDish?.id);
    const nextItem = sortedDishes[selectedIndex + 1];
    const isLastItem = selectedIndex === sortedDishes.length - 1;
    debugger
    if (!isLastItem && nextItem) {
      const qs = new URLSearchParams(window.location.search);
      qs.set("itemId", nextItem.id);
      
      navigate(`${window.location.pathname}?${qs.toString()}`)
    }
  };

  const onBack = () => {
    const selectedIndex = sortedDishes.findIndex((d) => d.id === selectedDish?.id);
    const prevItem = sortedDishes[selectedIndex - 1];
    const isFirstItem = selectedIndex === 0;

    if (!isFirstItem && prevItem) {
      const qs = new URLSearchParams(window.location.search);
      qs.set("itemId", prevItem.id);
      
      navigate(`${window.location.pathname}?${qs.toString()}`)
    }
  };

  return {
    onContinue,
    onBack,
  };
};

export default useDishNavigation;
